import { FaLayerGroup, FaHeart, FaCalendarAlt, FaMapMarkedAlt } from 'react-icons/fa';

const counter = [
  {
    id: 1,
    icon: <FaLayerGroup />, // Woodwork Projects icon
    title: 'Woodwork Projects',
    count: '20000',
  },
  {
    id: 2,
    icon: <FaHeart />, // Happy Clients icon
    title: 'Happy Clients',
    count: '30000',
  },
  {
    id: 3,
    icon: <FaCalendarAlt />, // Years of Experience icon
    title: 'Years of Experience',
    count: '25',
  },
  {
    id: 4,
    icon: <FaMapMarkedAlt />, // Service Locations icon
    title: 'Service Locations',
    count: '100',
  },
];

export default counter;